/**
 * Pure helpers the case file shares with its hosts — kept out of
 * InvestigationCaseFile.tsx so that file exports only components and
 * Vite's fast refresh keeps working for it (react-refresh/only-export-
 * components). CaseFileModal.tsx reads the status pill map from here.
 */
import type { DoorInvestigationRead } from '../../services/qcpInvestigations';
import styles from './InvestigationCaseFile.module.css';

/** The case-status pill's colour class, by lifecycle status. */
export const STATUS_PILL_CLASS: Record<DoorInvestigationRead['status'], string> = {
  investigating: styles.pillInvestigating,
  remediating: styles.pillRemediating,
  completed: styles.pillCompleted,
  cancelled: styles.pillCancelled,
};

/** A key value that is an internal identifier rather than something to read. */
export function isTechnicalKeyValue(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim());
}

/** Fold runs of identical history lines into one row with a count. */
export function collapseRepeats<T extends { summary: string }>(
  events: T[],
): Array<{ ev: T; times: number }> {
  const out: Array<{ ev: T; times: number }> = [];
  for (const ev of events) {
    const last = out[out.length - 1];
    if (last && last.ev.summary === ev.summary) last.times += 1;
    else out.push({ ev, times: 1 });
  }
  return out;
}
